import { Box, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getActiveBusinessInfo,
  getCommerceInfo,
} from "../../reducers/businessPreview/businessPreviewSlice";
import { BGColor02 } from "../../configs/styles/muiThemes";
import DashboardLayout from "../../components/Layouts/DashboardLayout";
import CatalogControlsContent from "./PreviewContent/CatalogControlsContent";
import { catalogPartnerGetAuth } from "../../service/api_calls/CatalogSync/CatalogSyncApi";
import { getInventorySummaryCounts } from "../../reducers/inventory/inventorySlice";
import ThreeDotLoader from "../../components/ThreeDotLoader";

function CatalogControls() {
  const dispatch = useDispatch();

  const [catalogPartnerAuth, setCatalogPartnerAuth] = useState(null);

  const {
    activeBusinessInfo,
    activeBusinessInfoLoader,
    commerceInfo,
    myBusinessData,
    myBusinessDataLoader,
  } = useSelector((state) => state.businessPreview);

  const { inventorySummary } = useSelector((state) => state.inventory);

  const getCatalogPartnerAuth = async (catalogPartner, bId) => {
    const res = await catalogPartnerGetAuth({
      businessId: bId,
      catalogPartner: catalogPartner?.toLowerCase(),
    });

    setCatalogPartnerAuth(res || null);
    return res
  };

  useEffect(() => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    if (businessId) {
      if (!activeBusinessInfo) {
        dispatch(getActiveBusinessInfo(businessId));
      }

      dispatch(getCommerceInfo(businessId)).then();

      if (!inventorySummary) {
        dispatch(getInventorySummaryCounts(businessId));
      }
    }
  }, []);

  return (
    <Box sx={styles.container}>
      <DashboardLayout
        activeMenu="eCommerceControls"
        activeSubMenu="catalogControls"
      >
        <Box
          display={{ md: "flex", xs: "block" }}
          pt={{ xs: 1, md: 0 }}
          justifyContent="center"
        >
          {!activeBusinessInfoLoader &&
          inventorySummary &&
          commerceInfo &&
          activeBusinessInfo ? (
            <CatalogControlsContent
              activeBusinessInfo={activeBusinessInfo}
              commerceInfo={commerceInfo}
              getCatalogPartnerAuth={getCatalogPartnerAuth}
              catalogPartnerAuth={catalogPartnerAuth}
              inventorySummary={inventorySummary}
            />
          ) : (
            <ThreeDotLoader />
          )}
        </Box>
      </DashboardLayout>
    </Box>
  );
}

export default CatalogControls;

const styles = {
  container: {
    backgroundColor: BGColor02,
    pb: { md: "15px", xs: "20px" },
    minHeight: "80vh",
  },

  content: {
    p: { xs: "0 0 20px", md: "15px 25px 25px 25px" },
    mx: { xs: "15px", md: "0px" },
  },

  stickyTop: {
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 100,
    pb: 1.5,
    backgroundColor: BGColor02,
  },

  menuStickyLeft: {
    position: { md: "sticky", xs: "static" },
    top: 0,
    left: 0,
    height: "100vh",
    zIndex: 100,
    backgroundColor: BGColor02,
  },
};
